<template>
    <div>
        <Header title="权限管理">
            <template v-slot:content>
                <div style="display: flex">
                    <div style="flex:1">
                    </div>
                    <div>
                        <Button type="primary"  @click="add">新增</Button>
                    </div>

                </div>
            </template>
        </Header>
        <div class="my-white-mod">
            <PageTable  :loading="table.loading"  :size="table.limit"   :columns="table.columns" :data="table.data" :current="table.current" :total="table.total" @switchPage="changepage" >
            </PageTable>
        </div>

        <Modal
                :mask-closable="false"
                v-model="show_infos"
                title="新增"
                width="400"
        >
            <div class="modal-title modal-title-two">选择权限</div>
            <Select    placeholder="请选择权限"   filterable v-model="submit_infos.power_id">
                <Option v-for="(item, index) in power_list" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
            <div class="modal-title modal-title-two">选择员工</div>
            <Select    placeholder="请选择员工" filterable v-model="submit_infos.department_member_id" >
                <Option v-for="(item, index) in departmentList" :value="item.id" :key="index">{{item.platform_name}}-{{ item.name }}</Option>
            </Select>
            <div slot="footer">
                <Button  type="primary"  @click="submitForm" >确定</Button >
            </div>
        </Modal>
    </div>

</template>
<script>
    import {power_department_list, team_department_list, power_select, add_power_department,del_power_department} from "@/api/system"
    import {Header, PageTable} from "@/components/mainLayout"
    export default {
        components:{
            Header,
            PageTable
        },
        data(){
            return{
                show_infos:false,
                departmentList:[],
                power_list:[],
                submit_infos:{
                    power_id:"",
                    department_member_id:""
                },
                table:{
                    loading:false,
                    current:1,
                    total:0,
                    limit:30,
                    columns: [
                        {
                            align:'center',
                            type: 'index'
                        },
                        {
                            title: '权限',
                            align:'center',
                            key: 'power_name',
                            width:200
                        },
                        {
                            title: '成员',
                            align:'center',
                            key: 'department_name'
                        },
                        {
                            title: '操作',
                            align:'center',
                            key: 'id',
                            render: (h, params) => {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small'
                                        },
                                        style:{color:'#3F8CFF', display:'inline-block !important'},
                                        on: {
                                            click: () => {
                                                this.edit(params)
                                            }
                                        }
                                    }, '编辑'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small'
                                        },
                                        style:{color:'#ff0000', display:'inline-block !important'},
                                        on: {
                                            click: () => {
                                                this.del_(params)
                                            }
                                        }
                                    }, '删除')
                                ]);

                            }
                        }
                    ],
                    data: []
                }

            }
        },
        mounted(){
            this.list();
            this.get_department_list()
            this.get_power_select()
        },
        methods:{
            add(){
                this.show_infos = true;
                this.submit_infos = {
                    power_id:"",
                    department_member_id:""
                }
            },
            edit(p){
                this.show_infos = true;
                let power_Arr = p.row.power_id.split(",")
                power_Arr.forEach(item => {
                    power_Arr.push(+item);
                });

                this.submit_infos = {
                    id:p.row.id,
                    power_id:power_Arr
                }
                for(let i in this.departmentList) {
                    let l = this.departmentList[i]
                    if (l.wx_uid == p.row.department_member_id && l.platform_id == p.row.platform_id) {
                        this.submit_infos.department_member_id = l.id
                    }
                }
            },
            del_(p){
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>是否删除角色权限？</p>',
                    onOk: () => {
                        del_power_department({id:p.row.id}).then(res=>{
                            if (res.code == 200) {
                                this.list()
                                this.$Message.success(res.msg);
                            } else {
                                this.$Message.error(res.msg)
                            }
                        })
                    }
                });
            },
            list(){
                this.table.loading = true
                power_department_list({limit:this.table.limit, page:this.table.current}).then(res=>{
                    this.table.loading = false
                    if (res.code == 200) {
                        this.table.data = res.data
                        this.table.total = res.total
                    } else {
                        this.table.data = []
                        this.table.total = 0
                        this.$Message.error(res.msg)
                    }
                })
            },
            changepage(e){
                this.table.current = e;
                this.list();
            },

            get_department_list(){
                team_department_list({type:1}).then(res=>{
                    this.departmentList = res.data
                })
            },

            get_power_select(){
                power_select({type:1}).then(res=>{
                    this.power_list = res.data
                })
            },
            submitForm(){
                if (this.submit_infos.power_id == "" || this.submit_infos.power_id == null) {
                    this.$Message.error("请选择权限");return
                }
                if (this.submit_infos.department_member_id == "" || this.submit_infos.department_member_id == null) {
                    this.$Message.error("请选择员工");return
                }
                add_power_department(this.submit_infos).then(res=>{
                    if(res.code == 200) {
                        this.show_infos = false
                        this.list()
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            }
        }
    }
</script>
